import { render, staticRenderFns } from "./SpecialAuthModal.vue?vue&type=template&id=4bf727f7&scoped=true&"
import script from "./SpecialAuthModal.vue?vue&type=script&lang=js&"
export * from "./SpecialAuthModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf727f7",
  null
  
)

export default component.exports